import { combineReducers } from 'redux'
import {
  SET_LOGIN_ROLE,
  SET_LOGIN_TOKEN,
  SET_ISLOGIN,
  RECEIVE_LOGIN_PROFILE,
  USER_FAKE_LOGIN,
  USER_LOGOUT,
  RECEIVE_NEWS,
  RECEIVE_URGENT,
  RECEIVE_FAQ,
  RECEIVE_SEMESTER,
  RECEIVE_SUSPEND,
  RECEIVE_TUTOR,
  RECEIVE_SUBJECT,
  RECEIVE_TIMETABLE,
  RECEIVE_SHOW_TIMESLOT,
  RECEIVE_DEFAULT_TIMESLOT,
  POP_ALERT,
  SET_LANG,
  RECEIVE_IMPORTANTDOCUMENT,
  RECEIVE_NORMALDOCUMENT,
} from '../../actions/basic/actions'

const initialLogin = {
  role: '',
  data: {},
  name: '',
  token: '',
  access: {},
}

function login(state = initialLogin, action) {
  switch (action.type) {
    case 'ADD_ROLE':
      return {
        ...state,
        access: { ...state.access, [action.role]: action.res },
      }
    case SET_LOGIN_ROLE:
      return {
        ...state,
        role: action.role,
        access: { ...state.access, [action.role]: true },
      }
    case SET_LOGIN_TOKEN:
      return {
        ...state,
        token: action.token,
      }
    case SET_ISLOGIN:
      return {
        ...state,
        role: action.role || state.role,
      }
    case RECEIVE_LOGIN_PROFILE:
      return {
        ...state,
        name: action.data.name,
        data: action.data,
      }
    case USER_FAKE_LOGIN:
      return { ...initialLogin, ...action.login }
    case USER_LOGOUT:
      return initialLogin
    default:
      return state
  }
}

function front(state = { timeSlot: [], defaultTimeSlot: [], lang: 'zh' }, action) {
  switch (action.type) {
    case RECEIVE_SHOW_TIMESLOT:
      return {
        ...state,
        timeSlot: action.data,
      }
    case RECEIVE_DEFAULT_TIMESLOT:
      return {
        ...state,
        defaultTimeSlot: action.data,
      }
    case SET_LANG:
      return {
        ...state,
        lang: action.lang,
      }
    default:
      return state
  }
}

// dashboard
const initialDB = {
  error: undefined,
  news: [],
  urgent: [],
  faq: [],
  normaldocs: [],
  importantdocs: [],
  semester: {
    list: [],
    current: undefined,
  },
  tutor: [],
  suspend: [],
  subject: [],
  timetable: [],
  alert: {
    msg: '',
    isSuccess: true,
    time: '',
  },
}

function alert(state, action) {
  switch (action.type) {
    case POP_ALERT:
      return {
        ...state,
        msg: action.msg,
        isSuccess: action.success,
        time: new Date(),
        hasShown: false,
      }
    case 'HAS_SHOWN':
      return {
        ...state,
        hasShown: true,
      }
    default:
      return state
  }
}

function db(state = initialDB, action) {
  switch (action.type) {
    case RECEIVE_NEWS:
      return { ...state, news: action.data }
    case RECEIVE_URGENT:
      return { ...state, urgent: action.data }
    case RECEIVE_FAQ:
      return { ...state, faq: action.data }
    case RECEIVE_NORMALDOCUMENT:
      return { ...state, normaldocs: action.data }
    case RECEIVE_IMPORTANTDOCUMENT:
      return { ...state, importantdocs: action.data }
    case RECEIVE_SEMESTER:
      return {
        ...state,
        semester: {
          list: action.data,
          current: action.current,
        },
      }
    case RECEIVE_SUSPEND:
      return { ...state, suspend: action.data }
    case RECEIVE_TUTOR:
      return { ...state, tutor: action.data }
    case RECEIVE_SUBJECT:
      return { ...state, subject: action.data }
    case RECEIVE_TIMETABLE:
      return { ...state, timetable: action.data }
    case POP_ALERT:
      return { ...state, alert: alert(state.alert, action) }
    default:
      return state
  }
}

const rootReducer = combineReducers({
  login,
  front,
  db,
})

export default rootReducer
